import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import thunk from 'redux-thunk';
import axios from 'axios';
import { composeWithDevTools } from 'redux-devtools-extension';
import { API_URL, PLATFORM_ID } from '../config'

export const api = axios.create({
    responseType: 'json',
    baseURL: API_URL,
    headers: {
      "Content-Type":"application/json",
      "TipoAmbienteId": PLATFORM_ID,
      "Plataforma": 1,
    }
});

// ⚠️ DevTools só em desenvolvimento — em produção usa compose padrão
const composeEnhancers =
  process.env.NODE_ENV === 'development' ? composeWithDevTools : compose;

const store = createStore(
    reducers, 
    composeEnhancers(
      applyMiddleware(thunk.withExtraArgument(api))
    ),
);

export default store;